var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgressing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MC/Progressing"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009435"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008015"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 40840",
    d: "M6.35294 12.0557H17.6471V16C17.6471 17.1046 16.7516 18 15.6471 18H8.35294C7.24837 18 6.35294 17.1046 6.35294 16V12.0557Z",
    fill: "#FCA66C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250695",
    d: "M10.5139 9.38079V6.70587H13.4861V9.38079L12 8.48915L10.5139 9.38079Z",
    fill: "#FCA66C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 40841",
    d: "M12 18H8.35294C7.24837 18 6.35294 17.1046 6.35294 16V12.3529V8.70587C6.35294 7.6013 7.24837 6.70587 8.35294 6.70587H9.32508H15.6471C16.7516 6.70587 17.6471 7.6013 17.6471 8.70587V9.38079V12.9474",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009434"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1209",
    d: "M9.33809 1.87423C4.958 3.07119 1.73259 7.15107 1.73259 12C1.73259 16.8489 4.958 20.9288 9.33809 22.1257M9.33809 1.87423L8.84078 4.21094M9.33809 1.87423L7.26118 0.705872",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1211",
    d: "M14.3694 22.147C18.9179 20.9718 22.2673 16.9661 22.2673 12.2053C22.2673 7.44457 18.9179 3.43887 14.3694 2.26367M14.3694 22.147L14.8858 19.8528M14.3694 22.147L16.5261 23.2941",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressing);
export default __webpack_public_path__ + "static/media/Progressing.ddacb6eb09e2b23181094fcfb524816d.svg";
export { ForwardRef as ReactComponent };